'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var index$1 = require('../../../components/Language/index.js');
require('../../../components/Spinner/Spinner.module.css.js');
require('../../../components/LocationCard/LocationCard.js');
var PudoCard = require('../../../components/PudoCard/PudoCard.js');
require('../../../components/ItemCard/ItemCard.js');
require('../../../components/SelectItem/SelectItem.js');
require('../../../components/SelectList/SelectList.js');
require('../../../components/ErrorBanner/ErrorBanner.js');
require('../../../components/Footer/Footer.js');
require('../../../components/StickyFooter/StickyFooter.js');
require('../../../components/SwatchesList/SwatchesList.js');
var index = require('../../../components/TextLink/index.js');
require('../../../components/Backdrop/Backdrop.module.css.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/Skeleton.module.css.js');
var title = require('../RootElm/title.js');
var pudoMethod = require('../../../transformers/pudoMethod.js');
var PreferencesStatus = require('../../../components/Preferences/PreferencesStatus.js');
var PudoCardList_module = require('./PudoCardList.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PudoCards = _ref => {
  let {
    pudoOptions,
    onValueChange,
    defaultValue,
    headerTitle,
    preferencesStatus,
    showSwitchCategory,
    locale,
    includeCurrency
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: PudoCardList_module["default"].pudoElmWrap
  }, /*#__PURE__*/React__default["default"].createElement(title["default"], {
    headerTitle: headerTitle
  }), preferencesStatus && pudoOptions.some(opt => opt.preferred) && /*#__PURE__*/React__default["default"].createElement(PreferencesStatus["default"], preferencesStatus), /*#__PURE__*/React__default["default"].createElement("div", {
    className: PudoCardList_module["default"].pudoGroup
  }, defaultValue ? pudoOptions.filter(item => pudoMethod.generatePudoId(item) === pudoMethod.generatePudoId(defaultValue)).map(option => /*#__PURE__*/React__default["default"].createElement(PudoCard["default"], _extends__default["default"]({}, option, {
    defaultValue,
    locale,
    includeCurrency,
    key: pudoMethod.generatePudoId(option)
  }))) : pudoOptions.map(option => /*#__PURE__*/React__default["default"].createElement(PudoCard["default"], _extends__default["default"]({}, option, {
    defaultValue,
    locale,
    includeCurrency,
    key: pudoMethod.generatePudoId(option),
    onClick: () => onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(pudoMethod.generatePudoId(option))
  })))), defaultValue && showSwitchCategory && /*#__PURE__*/React__default["default"].createElement("div", {
    className: PudoCardList_module["default"].pudoExtraActions
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    onClick: () => onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(''),
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    }
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoListSwitchCategory"
  }))));
};
var PudoCards$1 = nthHookTheme.withThemeProvider(PudoCards, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
});

exports["default"] = PudoCards$1;
